import { call, put } from 'redux-saga/effects';
import UpdateNotesOfGoalActions from '../redux/UpdateNotesOfGoalRedux';
import { api } from './api';

export function* updatenotesofgoalsagas(action: any): Generator<any, void, any> {
  const { id, notes } = action;
  const response = yield call(api.updateNotesOfGoal, id, notes);

  // success?
  if (response.ok) {
    // You might need to change the response here - do this with a 'transform',
    // located in ../Transforms/. Otherwise, just pass the data back from the api.
    yield put(UpdateNotesOfGoalActions.updateNotesOfGoalSuccess(response.data));
  } else {
    yield put(UpdateNotesOfGoalActions.updateNotesOfGoalFailure());
  }
}